"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _customPage = require("@/api/customPage");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: ['itemDetail'],
  data: function data() {
    return {
      toolbarStyle: {},
      dataList: []
    };
  },
  mounted: function mounted() {
    var _this = this;
    (0, _customPage.moduleDetail)({
      moduleId: this.$props.itemDetail.moduleId
    }).then(function (res) {
      _this.dataList = res.data.banner;
      _this.toolbarStyle = res.data.toolbarStyle;
    });
  },
  methods: {}
};